import { useQuery } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { BookedEvents } from '../../types/Types';

interface UseGetUserProps {
  id: string;
  enabled?: boolean;
}

export function useGetBookedEvents({ id, enabled = true }: UseGetUserProps) {
  return useQuery({
    enabled,
    queryKey: ['booked-events', id],
    queryFn: async () => {
      return axiosInstance<BookedEvents>(getAPIURL(`/Event/eventsUserWillBeAttending/${id}`)).then(
        (response) => response.data,
      );
    },
  });
}